// extracted by css-extract-rspack-plugin
module.exports =  {"diff":"AnswerDiff-Er4y__diff","incorrect":"AnswerDiff-v1YN__incorrect","missing":"AnswerDiff-Fdfn__missing"};